module.exports = __webpack_public_path__ + "static/media/bbc_news_election_us2016_results_plot.fe745228.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_election_us2016_results_plot.png
// module id = 346
// module chunks = 0